import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { CableColor, CableType } from "../enums/enums";

export type CableFormValues = { type: CableType; color: CableColor };

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: CableFormValues) => void | Promise<void>;
};

export default function CableFormDialog({ open, onClose, onSubmit }: Props) {
  const [type, setType] = useState<CableType>(CableType.ONE_BY_TWELVE);
  const [color, setColor] = useState<CableColor>(CableColor.RED);

  const handleSave = async () => {
    await onSubmit({ type, color });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Детали за кабел</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mb: 2 }} />
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="type-label">Тип</InputLabel>
          <Select
            labelId="type-label"
            label="Тип"
            value={type}
            onChange={(e) => setType(e.target.value as CableType)}
          >
            {Object.values(CableType).map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="color-label">Боја</InputLabel>
          <Select
            labelId="color-label"
            label="Боја"
            value={color}
            onChange={(e) => setColor(e.target.value as CableColor)}
          >
            {Object.values(CableColor).map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Откажи</Button>
        <Button onClick={handleSave} variant="contained">
          Сними
        </Button>
      </DialogActions>
    </Dialog>
  );
}
